import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Navimumbaiairportcab() {



  const cardData =
  {
    keyword: ' Navi Mumbai Airport Cab  ',
    heading: 'Sai Trupti Cabs:  Navi Mumbai Airport Cab   ',
    headingDescription: 'Sai Trupti Cabs offers reliable and punctual Navi Mumbai Airport cab service (NMIA), ensuring smooth and stress-free airport pickup and drop for all travelers. Our fleet includes well-maintained AC sedans, SUVs, Innova Crysta, and premium vehicles, all equipped with clean interiors and ample luggage space for comfortable airport transfers. Every ride is handled by a professional, background-verified driver who ensures on-time pickup, safe driving, and courteous service throughout your journey. We provide flexible options like airport pickup, drop service, one way cab, and corporate airport transfers at transparent and affordable pricing with no hidden charges. With 24x7 online cab booking, instant confirmation, and dedicated customer support, Sai Trupti Cabs makes your Navi Mumbai Airport travel convenient, reliable, and completely hassle-free.',

    top: 'Top Places to Visit in Navi Mumbai with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Pandavkada Falls",
    "description": "Pandavkada Falls is a scenic waterfall located in Kharghar, Navi Mumbai. Surrounded by lush greenery and rocky cliffs, it becomes especially spectacular during the monsoon season. The falls are associated with legends of the Pandavas from the Mahabharata. Visitors can enjoy trekking, photography, and picnics, making it a perfect spot for nature lovers and adventure enthusiasts."
  },
  {
    "title": "Central Park, Kharghar",
    "description": "Central Park in Kharghar is one of Navi Mumbai’s largest and most beautifully landscaped parks. Spread over 100 acres, it features jogging tracks, amphitheaters, a musical fountain, and lush green lawns. The park is ideal for family outings, morning walks, and recreational activities. Its serene environment provides a peaceful escape from the urban hustle."
  },
  {
    "title": "Belapur Fort",
    "description": "Belapur Fort is a historic fort built by the Siddis of Janjira in the 16th century. Though partially in ruins, it offers insight into Navi Mumbai’s history and strategic importance during medieval times. Visitors can explore the fort’s walls, watchtowers, and surrounding greenery while enjoying panoramic views of the area."
  },
  {
    "title": "Karnala Bird Sanctuary",
    "description": "Karnala Bird Sanctuary, located near Navi Mumbai, is a haven for bird watchers and nature enthusiasts. The sanctuary is home to over 150 species of resident and migratory birds. It also features the historic Karnala Fort, which offers a moderate trekking experience with rewarding views of the surrounding forest and wildlife."
  },
  {
    "title": "Kharghar Hills",
    "description": "Kharghar Hills are part of the scenic Western Ghats and provide trekking trails, nature walks, and panoramic views of Navi Mumbai and surrounding areas. The hills are ideal for adventure enthusiasts and photographers, especially during sunrise and sunset. They offer a peaceful retreat in the lap of nature."
  },
  {
    "title": "Shivaji Chowk, Vashi",
    "description": "Shivaji Chowk is a bustling commercial and cultural hub in Vashi, Navi Mumbai. Known for its shopping complexes, eateries, and vibrant street life, it offers a taste of the city’s modern urban culture. Visitors can enjoy local cuisine, shopping, and lively city vibes."
  },
  {
    "title": "Seawoods Grand Central Mall",
    "description": "Seawoods Grand Central Mall is a modern shopping and entertainment destination in Navi Mumbai. It features retail stores, restaurants, cinemas, and recreational areas. The mall is ideal for shopping enthusiasts, families, and tourists looking for leisure and entertainment in a contemporary setting."
  },
  {
    "title": "Utsav Chowk",
    "description": "Utsav Chowk is a landmark in Kharghar, Navi Mumbai, known for its beautiful architecture and illuminated fountain. The area is popular for evening walks, photography, and cultural events. Utsav Chowk serves as a vibrant gathering spot reflecting the city’s planned urban design and aesthetic appeal."
  },
  {
    "title": "DY Patil Stadium",
    "description": "DY Patil Stadium in Nerul is one of India’s premier sports stadiums, hosting cricket matches, football games, and large events. The stadium is renowned for its modern facilities and vibrant atmosphere during matches. Sports enthusiasts and tourists often visit to witness live events and experience the energetic ambiance."
  },
  {
    "title": "Nerul Balaji Temple",
    "description": "Nerul Balaji Temple is a serene temple dedicated to Lord Balaji, located in Nerul, Navi Mumbai. Known for its spiritual ambiance and beautiful architecture, the temple attracts devotees year-round. Visitors can participate in rituals, seek blessings, and enjoy the peaceful surroundings of this sacred site."
  }
],



  "services": [
    {
      "name": "Navi Mumbai Airport Cab",
      "description": "Reliable cab service to and from Navi Mumbai Airport with AC/non-AC vehicles including Sedans, SUVs, Innova, and luxury cars. Offers professional drivers, luggage support, flexible pickup/drop points, real-time tracking, and transparent fares. Ideal for solo travelers, families, corporate clients, and airport transfers."
    },
    {
      "name": "Navi Mumbai Airport Taxi",
      "description": "Efficient taxi service to and from Navi Mumbai Airport with AC/non-AC rides, experienced drivers, luggage assistance, flexible schedules, and online booking. Perfect for one-way or round-trip airport transfers for business or leisure travelers."
    },
    {
      "name": "Navi Mumbai Airport Cab Service",
      "description": "Full-featured cab service for Navi Mumbai Airport offering comfortable AC/non-AC vehicles, professional drivers, luggage support, real-time tracking, and flexible pickup/drop points. Suitable for family trips, corporate travel, and group transfers."
    },
    {
      "name": "Navi Mumbai Airport Taxi Service",
      "description": "Professional taxi service to Navi Mumbai Airport with AC/non-AC options, experienced drivers, luggage support, flexible schedules, and secure online booking. Ideal for quick airport transfers, corporate travel, and late-night or early morning trips."
    },
    {
      "name": "Cab to Navi Mumbai Airport",
      "description": "Convenient cab service to Navi Mumbai Airport with AC/non-AC Sedans, SUVs, Innova, and luxury vehicles. Features professional drivers, luggage assistance, flexible pickup points, real-time tracking, and transparent fares for safe and timely airport transfers."
    },
    {
      "name": "Taxi to Navi Mumbai Airport",
      "description": "Reliable taxi service to Navi Mumbai Airport offering AC/non-AC rides, professional drivers, luggage support, flexible pickup/drop points, and online booking for hassle-free transfers for solo travelers, families, or business clients."
    },
    {
      "name": "Navi Mumbai Airport Pickup Cab",
      "description": "Pickup cab service from Navi Mumbai Airport with AC/non-AC vehicles, professional drivers, luggage support, flexible schedules, and real-time tracking. Ensures comfortable and timely travel from the airport to your destination."
    },
    {
      "name": "Navi Mumbai Airport Drop Taxi",
      "description": "Drop taxi service to Navi Mumbai Airport offering AC/non-AC vehicles, professional drivers, luggage assistance, flexible schedules, and reliable transfers for business travelers, families, and individuals."
    },
    {
      "name": "Navi Mumbai Airport Cab Booking",
      "description": "Book your Navi Mumbai Airport cab online instantly with multiple vehicle options, AC/non-AC rides, professional drivers, luggage support, flexible pickup/drop points, real-time tracking, and transparent fares for a hassle-free airport transfer."
    },
    {
      "name": "Navi Mumbai Airport Taxi Booking Online",
      "description": "Online taxi booking service for Navi Mumbai Airport offering AC/non-AC vehicles, professional drivers, luggage assistance, flexible schedules, and transparent fares for one-way or round-trip airport transfers."
    },
    {
      "name": "Best Navi Mumbai Airport Cab Service",
      "description": "Top-rated airport cab service providing comfortable AC/non-AC vehicles, professional drivers, luggage support, flexible schedules, real-time tracking, and transparent fares for safe and reliable travel to or from Navi Mumbai Airport."
    },
    {
      "name": "Cheap Navi Mumbai Airport Cab",
      "description": "Affordable airport cab service in Navi Mumbai offering AC/non-AC Sedans, SUVs, and Innova at budget-friendly fares with professional drivers, luggage assistance, flexible pickup/drop points, and transparent pricing."
    },
    {
      "name": "24x7 Navi Mumbai Airport Taxi",
      "description": "Round-the-clock taxi service for Navi Mumbai Airport with AC/non-AC rides, experienced drivers, luggage support, flexible pickup/drop points, real-time tracking, and secure online booking for any time of day or night."
    },
    {
      "name": "Pre-Book Navi Mumbai Airport Cab",
      "description": "Pre-book your Navi Mumbai Airport cab in advance with AC/non-AC vehicles, professional drivers, luggage assistance, flexible pickup/drop points, real-time tracking, and transparent fares for worry-free airport transfers."
    },
    {
      "name": "Innova Cab Navi Mumbai Airport",
      "description": "Spacious Innova cab service for Navi Mumbai Airport offering AC rides, comfortable seating, professional drivers, luggage support, flexible pickup/drop points, and transparent fares for families, groups, or corporate travelers."
    },
    {
      "name": "Innova Crysta Airport Cab Navi Mumbai",
      "description": "Premium Innova Crysta cab service for Navi Mumbai Airport providing luxury AC rides, professional chauffeurs, luggage assistance, comfortable seating, flexible pickup/drop points, and reliable airport transfers."
    },
    {
      "name": "Ertiga Airport Cab Navi Mumbai",
      "description": "Ertiga cab service for Navi Mumbai Airport with AC/non-AC rides, seating for small to medium groups, professional drivers, luggage support, flexible schedules, and comfortable airport transfers."
    },
    {
      "name": "Sedan Airport Taxi Navi Mumbai",
      "description": "Sedan taxi service for Navi Mumbai Airport offering smooth AC/non-AC rides, professional drivers, luggage assistance, flexible pickup/drop points, and reliable transfers for solo travelers, couples, or small families."
    },
    {
      "name": "SUV Airport Cab Navi Mumbai",
      "description": "Spacious SUV cab service for Navi Mumbai Airport with AC/non-AC options, professional drivers, luggage support, flexible pickup/drop points, and comfortable travel for families or groups."
    },
    {
      "name": "Luxury Airport Cab Navi Mumbai",
      "description": "Premium luxury cab service to Navi Mumbai Airport offering top-class vehicles, professional chauffeurs, luggage support, flexible pickup/drop points, and real-time tracking for VIP travelers and corporate clients."
    },
    {
      "name": "Corporate Airport Cab Navi Mumbai",
      "description": "Corporate cab service for Navi Mumbai Airport with AC/non-AC vehicles, professional drivers, luggage support, flexible schedules, real-time tracking, and transparent fares for executives and business travelers."
    },
    {
      "name": "Airport Pickup Drop Service Navi Mumbai",
      "description": "Comprehensive airport pickup and drop service in Navi Mumbai with AC/non-AC vehicles, professional drivers, luggage assistance, flexible schedules, and real-time tracking for safe and reliable transfers."
    },
    {
      "name": "Late Night Airport Cab Navi Mumbai",
      "description": "Safe late-night cab service to or from Navi Mumbai Airport with AC/non-AC vehicles, experienced drivers, luggage support, flexible schedules, and 24x7 availability."
    },
    {
      "name": "Early Morning Airport Taxi Navi Mumbai",
      "description": "Reliable early morning airport taxi service in Navi Mumbai offering AC/non-AC vehicles, professional drivers, luggage assistance, flexible pickup/drop points, and real-time tracking for timely travel."
    },
    {
      "name": "Safe Airport Cab for Family",
      "description": "Family-friendly cab service for Navi Mumbai Airport providing safe and comfortable AC/non-AC vehicles, professional drivers, luggage support, flexible schedules, and reliable travel for family trips."
    },
    {
      "name": "Navi Mumbai Airport to Pune Cab",
      "description": "Long-distance cab service from Navi Mumbai Airport to Pune with AC/non-AC Sedans, SUVs, Innova, and luxury vehicles, professional drivers, luggage assistance, flexible pickup/drop points, and transparent fares."
    },
    {
      "name": "Navi Mumbai Airport to Nashik Cab",
      "description": "Outstation cab service from Navi Mumbai Airport to Nashik offering AC/non-AC vehicles, professional drivers, luggage support, flexible schedules, real-time tracking, and reliable long-distance travel."
    },
    {
      "name": "Navi Mumbai Airport to Mahabaleshwar Cab",
      "description": "Comfortable cab service from Navi Mumbai Airport to Mahabaleshwar with AC/non-AC vehicles, experienced drivers, luggage assistance, flexible pickup/drop points, and safe long-distance travel."
    },
    {
      "name": "Navi Mumbai Airport to Kolhapur Cab",
      "description": "Reliable cab service from Navi Mumbai Airport to Kolhapur offering AC/non-AC vehicles, professional drivers, luggage support, flexible schedules, real-time tracking, and transparent fares for long-distance travel."
    },
    {
      "name": "Navi Mumbai Airport to Sambhajinagar Cab",
      "description": "Long-distance cab service from Navi Mumbai Airport to Sambhajinagar with AC/non-AC Sedans, SUVs, and Innova, professional drivers, luggage support, flexible schedules, and transparent fares."
    },
    {
      "name": "Navi Mumbai Airport to Goa Cabs",
      "description": "Outstation cab service from Navi Mumbai Airport to Goa offering AC/non-AC vehicles, professional drivers, luggage assistance, flexible pickup/drop points, real-time tracking, and reliable long-distance travel for leisure or corporate trips."
    },
    {
      "name": "Navi Mumbai Airport to Lonavala Cabs",
      "description": "Comfortable cab service from Navi Mumbai Airport to Lonavala with AC/non-AC vehicles, experienced drivers, luggage support, flexible pickup/drop points, and safe travel for short or long-distance journeys."
    }
  ],
  "tableData": [
    ["Navi Mumbai Airport Cab", "Navi Mumbai Airport Taxi"],
    ["Navi Mumbai Airport Cab Service", "Navi Mumbai Airport Taxi Service"],
    ["Cab to Navi Mumbai Airport", "Taxi to Navi Mumbai Airport"],
    ["Navi Mumbai Airport Pickup Cab", "Navi Mumbai Airport Drop Taxi"],
    ["Navi Mumbai Airport Cab Booking", "Navi Mumbai Airport Taxi Booking Online"],
    ["Best Navi Mumbai Airport Cab Service", "Cheap Navi Mumbai Airport Cab"],
    ["24x7 Navi Mumbai Airport Taxi", "Pre-Book Navi Mumbai Airport Cab"],
    ["Innova Cab Navi Mumbai Airport", "Innova Crysta Airport Cab Navi Mumbai"],
    ["Ertiga Airport Cab Navi Mumbai", "Sedan Airport Taxi Navi Mumbai"],
    ["SUV Airport Cab Navi Mumbai", "Luxury Airport Cab Navi Mumbai"],
    ["Corporate Airport Cab Navi Mumbai", "Airport Pickup Drop Service Navi Mumbai"],
    ["Late Night Airport Cab Navi Mumbai", "Early Morning Airport Taxi Navi Mumbai"],
    ["Safe Airport Cab for Family", "Navi Mumbai Airport to Pune Cab"],
    ["Navi Mumbai Airport to Nashik Cab", "Navi Mumbai Airport to Mahabaleshwar Cab"],
    ["Navi Mumbai Airport to Kolhapur Cab", "Navi Mumbai Airport to Sambhajinagar Cab"],
    ["Navi Mumbai Airport to Goa Cabs", "Navi Mumbai Airport to Lonavala Cabs"]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Navi Mumbai Airport Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs offers reliable and comfortable cab services to and from Navi Mumbai Airport — perfect for business travelers, airport pickups, and family trips."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Our fares for Navi Mumbai Airport cabs start from approximately ₹800–₹1,200 for sedans, with SUVs and premium cars available at affordable rates depending on distance and vehicle type."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, or premium cars to suit your luggage, group size, and comfort preferences for airport transfers."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are familiar with Navi Mumbai and Mumbai routes, ensuring a safe, smooth, and timely airport transfer."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We offer convenient pickups and drop-offs anywhere in Navi Mumbai, Mumbai, or surrounding areas — including homes, offices, hotels, and stations."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All vehicles are regularly serviced, sanitized, and equipped with essential amenities to ensure a comfortable and hygienic ride to the airport."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to help with bookings, flight coordination, and route assistance for your Navi Mumbai Airport cab."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Navi Mumbai Airport cab easily through a call, WhatsApp, or our website — with instant confirmation and prompt vehicle dispatch."
  }
]



  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs offer Navi Mumbai Airport cab services?',
    answer: 'Yes, Sai Trupti Cabs provides reliable and affordable cab services for pickups and drop-offs at Navi Mumbai Airport.',
  },
  {
    question: 'How can I book a Navi Mumbai Airport cab with Sai Trupti Cabs?',
    answer: 'You can book your cab through our website, mobile app, WhatsApp, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of cabs are available for Navi Mumbai Airport transfers?',
    answer: 'We offer hatchbacks, sedans, SUVs, and premium cars for Navi Mumbai Airport cab services.',
  },
  {
    question: 'Are the drivers experienced for airport transfers?',
    answer: 'Yes, all our drivers are professional, courteous, and familiar with Navi Mumbai and Mumbai airport routes.',
  },
  {
    question: 'Can I book a cab for multiple airport trips?',
    answer: 'Yes, we provide flexible options for multiple pickups and drop-offs, including round trips.',
  },
  {
    question: 'Is the Navi Mumbai Airport cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services for airport transfers for maximum convenience.',
  },
  {
    question: 'What are the fares for Navi Mumbai Airport cabs?',
    answer: 'Fares start from approximately ₹800 for sedans and ₹1,200–₹2,000 for SUVs and premium vehicles, depending on distance and vehicle type.',
  },
  {
    question: 'What payment options are accepted for Navi Mumbai Airport cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets.',
  },
  {
    question: 'What safety and hygiene protocols are followed for airport cabs?',
    answer: 'All vehicles are sanitized before every trip, and drivers follow strict hygiene and safety measures.',
  },
  {
    question: 'Is customer support available during the airport cab ride?',
    answer: 'Yes, our 24×7 customer support team is available throughout your Navi Mumbai Airport cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Patil',
    feedback: 'Booked a Navi Mumbai Airport cab. Comfortable ride, timely pickup, and very professional driver.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Deshmukh',
    feedback: 'Excellent service for airport transfer. Clean cab and courteous driver made my trip stress-free.',
    rating: 5,
  },
];



















































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Navi Mumbai Airport Cab Service",
  "image": "https://saitrupticabs.com/assets/images/navi-mumbai-airport-cab.jpg",
  "description": "Sai Trupti Cabs provides Navi Mumbai Airport cab service for NMIA pickup and drop. Book AC sedan, SUV and Innova Crysta for airport transfer with on-time service, professional drivers and 24x7 online booking.",
  "provider": {
    "@type": "Organization",
    "name": "Sai Trupti Cabs",
    "url": "https://saitrupticabs.com"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Navi Mumbai International Airport"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "11860"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1499",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/navi-mumbai-airport-cab"
  }
};








  return (
    <div>


<Helmet>
  <title>Navi Mumbai Airport Cab | NMIA Pickup Drop ₹1499 | Sai Trupti Cabs</title>

  <meta 
    name="description" 
    content="Book Navi Mumbai Airport cab for NMIA pickup and drop at ₹1499. AC sedan, SUV and Innova Crysta available with Sai Trupti Cabs. On-time airport taxi with 24x7 booking." 
  />

  <meta 
    name="keywords" 
    content="nmia airport cab, navi mumbai airport cab, navi mumbai airport taxi, nmia pickup drop cab, airport cab navi mumbai, navi mumbai airport taxi service, nmia airport transfer, cheap airport cab navi mumbai, innova airport cab nmia, sedan airport taxi navi mumbai, airport cab booking nmia, 24 hour airport taxi navi mumbai" 
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/97.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaiairportcab;